import type { IMasterDataDeductionCategoryRepository } from "@src/domain/repositories/masterData";
import type { DeleteMasterDataDeductionCategoriesDTO } from "@src/domain/dto/masterData";

export class DeleteMasterDataDeductionCategoriesUseCase {
  private readonly repository: IMasterDataDeductionCategoryRepository;

  constructor(repository: IMasterDataDeductionCategoryRepository) {
    this.repository = repository;
  }

  execute(params: DeleteMasterDataDeductionCategoriesDTO) {
    return this.repository.deleteDeductionCategories(params);
  }
}
